import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMapPin = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M27 13C27 6.92487 22.0751 2 16 2C9.92487 2 5 6.92487 5 13C5 17.2198 6.97681 21.2723 10.2454 25.0312C11.3744 26.3296 12.5818 27.5007 13.7899 28.5276L14.0405 28.7385L14.5187 29.1287L14.9631 29.4762L15.3648 29.7754L15.4265 29.8192C15.7709 30.0603 16.2291 30.0603 16.5735 29.8192L16.9142 29.5694L17.0369 29.4762L17.4813 29.1287L17.9595 28.7385L18.2101 28.5276C19.4182 27.5007 20.6256 26.3296 21.7546 25.0312C25.0232 21.2723 27 17.2198 27 13ZM7 13C7 8.02944 11.0294 4 16 4C20.9706 4 25 8.02944 25 13C25 16.6552 23.2268 20.2902 20.2454 23.7188C19.1869 24.936 18.0506 26.0383 16.9149 27.0037L16.6805 27.2009L16.2346 27.5648L16 27.75L15.7654 27.5648L15.3195 27.2009L15.2032 27.1036L14.5986 26.5816C13.6264 25.7211 12.6619 24.7622 11.7546 23.7188C8.77319 20.2902 7 16.6552 7 13ZM16 8C18.7614 8 21 10.2386 21 13C21 15.7614 18.7614 18 16 18C13.2386 18 11 15.7614 11 13C11 10.2386 13.2386 8 16 8ZM13 13C13 11.3431 14.3431 10 16 10C17.6569 10 19 11.3431 19 13C19 14.6569 17.6569 16 16 16C14.3431 16 13 14.6569 13 13Z"
	})
});
export default SvgMapPin;
